<template>
  <v-container fluid fill-height>
    <v-layout align-left justify-start>
      <v-flex xs12 sm10 md6 lg4>
        <!-- page title -->
        <backButton/>

        <br>

        <v-card class="elevation-5 px-4 pt-1 pb-4">
          <!-- card title -->
          <v-card-title class="pl-0">
            <h2 class="card__title">Подтверждение устройства</h2>
          </v-card-title>

          <!-- card body -->
          <v-card-text>
            <p class="card__paragraph">Для подтверждения устройства воспользуйтесь следующей инструкцией:</p>

            <p class="card__paragraph">
            <ol>
              <li class="mb-1">Скачайте приложение “Безопасный город” из
                <a class="blue_3--text" href="//play.google.com/store" target="_blank">Google Play</a> или <a  class="blue_3--text" href="//www.apple.com/ru/ios/app-store/" target="_blank">App Store</a></li>
              <li>Используйте код подтверждения для активации устройства</li>
            </ol>
          </p>


          <!-- card code -->
          <span class="card__desc">Ваш код подтверждения</span>
          <div class="blue_5 confirm-divice">
            <span class="card__paragraph">339981fba</span>
          </div>

            <br>

          <!-- card button -->
          <v-btn class="btn ml-0" color="indigo_5" large dark>К списку устройств</v-btn>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>




<script>
import backButton from "@/components/backButton";

export default {
  name: "confirm",

  components: {
    backButton
  },

  data: () => ({}),

  methods: {}
};
</script>




<style lang="scss" scoped>
@import "@/style/global.scss";
ol {
  list-style-type: none;
  counter-reset: item;
}
li:before {
  content: counter(item) ") ";
  counter-increment: item;
}

.confirm-divice {
  max-width: 122px;
  padding: 5px 0;
  text-align: center;
}
</style>

